import { createSelector } from '@ngrx/store';
import { announcementDetailEntitiesAdapter } from './announcement-detail-entities.adapter';
import { selectEntities } from '../entities';

/**
 * Selectors für Announcement-Detail-Entities.
 */
export class AnnouncementDetailEntitiesSelectors {
  private static readonly adapterSelectors = announcementDetailEntitiesAdapter.getSelectors();

  private static readonly _feature = createSelector(
    selectEntities,
    (state) => state.announcementDetailEntities,
  );

  /** Alle Detail-Entities als Array. */
  static readonly details = createSelector(
    this._feature,
    this.adapterSelectors.selectAll,
  );

  /** Detail-Entities als Dictionary (ID → Entity). */
  static readonly detailEntities = createSelector(
    this._feature,
    this.adapterSelectors.selectEntities,
  );

  /**
   * Einzelnes Detail per ID.
   * @param id - Die ID des Announcements
   */
  static detailById(id: string) {
    return createSelector(
      this.detailEntities,
      (entities) => entities[id] ?? null,
    );
  }

  /** Ladezustand für die Detail-Daten. */
  static readonly isLoadingDetail = createSelector(
    this._feature,
    (state) => state.isLoadingDetail,
  );

  /** Gibt an, ob Detail-Daten mindestens einmal geladen wurden (Anti-Flicker). */
  static readonly isDetailLoaded = createSelector(
    this._feature,
    (state) => state.isDetailLoaded,
  );

  /** Fehlermeldung beim Laden der Detail-Daten. */
  static readonly detailError = createSelector(
    this._feature,
    (state) => state.detailError,
  );
}
